document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.mp-tab-btn');
  const contents = document.querySelectorAll('.mp-tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      document.getElementById(tab.dataset.target).classList.add('active');
    });
  });
});
